/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/camelcase */
<template>
  <div class="">
    <section class="title">
      <div class="header__text-box">
        <h1 class="heading-primary">
          <span
            class="heading-primary--main"
          >Edit Blog</span>
        </h1>
      </div>
    </section>
    <div class="card full">
      <div class="heading-tertiary">
        Title {{ blog.uid }}
      </div>
      <div class="form__group">
        <input
          v-model="title"
          type="text"
          class="form__input"
          :placeholder="blog.title"
          required
          autocomplete="off"
        >
        <label
          for="name"
          class="form__label"
        >Blog Title</label>
      </div>
      <div class="heading-tertiary">
        Tags
      </div>
      <div v-if="options.length > 0">
        <multiselect
          v-model="value"
          :multiple="true"
          :options="options"
          :taggable="true"
          tag-placeholder="Add this as new tag"
          @tag="addTag"
        />
      </div>
      <div class="heading-tertiary">
        Project <input
        v-model="project"
  type="checkbox"
   />
      </div>
     
      <div class="heading-tertiary">
        Cover Image
      </div>
      <FileUploader
        :coverimage="selectedCoverImage"
        @coverImageSelected="setSelectedImage"
      />
      <vue-editor
        v-model="blog.body"
        class="u-margin-tb-medium"
        use-custom-image-handler
        @image-added="handleImageAdded"
      />
      <button
        class="btn-tiled quaternary"
        style="float:right; "
        @click="publishBlog()"
      >
        Publish
      </button>
      <button
        class="btn-tiled primary"
        style="float:right; margin-right: 1rem;"
        @click="draftBlog()"
      >
        Draft
      </button>
      <button
        class="btn-tiled tertiary"
        style="float:right; margin-right: 1rem;"
        @click="deleteBlog()"
      >
        Delete
      </button>
      <div v-if="feedback.length > 0">
        <div
          v-for="(item, value) in feedback"
          :key="value"
        >
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import FileUploader from '@/components/shared/FileUploader'
import axios from 'axios'

import Multiselect from 'vue-multiselect'
import { getTags, editBlogToFirebase, deleteBlog } from '@/functions/blog'
import {
  getFirebaseCollectionNoOrder,
  getFirebaseCollectionWhere,
  postNewTagsToFirebase,
  updatePostTagsToFirebase,
  getFirebaseDocumentFromCollection
} from "@/functions/firebase/base";
import { post } from 'jquery'

export default {
  name: 'EditBlog',
  components: {
    VueEditor,
    FileUploader,
    Multiselect
  },
  data () {
    return {
      selectedAuthor: null,
      blog: [],
      uploadCoverImage: null,
      selectedCoverImage: null,
      users: null,
      feedback: [],
      title: null,
      value: [],
      tags: [],
      blogtags: null,
      resolvedTags: [],
      options: [],
      project: false,
    }
  },
  mounted () {
    if (this.$route.params.blog) {
      this.blog = this.$route.params.blog
      this.title = this.$route.params.blog.title
    }

    // check if default image is selected
    if (this.blog.coverImage) {
      this.selectedCoverImage = this.blog.coverImage
    }

     Promise.all([this.getAllTags()])

  },
  methods: {
    getAllTags (){
        getFirebaseDocumentFromCollection(process.env.VUE_APP_DB_TAGS_POST, this.blog.uid)
       .then((result) => 
        result.forEach(element => {
         element.tags.forEach(element => {
           this.value.push(element)
         })
        }))       
         getFirebaseCollectionNoOrder(process.env.VUE_APP_DB_TAGS)
         .then((result) => result.forEach(element => {
          this.options.push(element.data.tag)
        }))
    },
    flattenTags (result){
        result.forEach(element => {
            this.tags.push(element.data)
        });
    },
    filterBlogTags (tags){
      return tags.filter(element =>  element.blogId ===  this.blog.uid)
    },
    addTag (newTag) {
      this.options.push(newTag)
      this.value.push(newTag)
      this.resolvedTags.push(newTag)
    },
    setSelectedImage (value) {
      this.selectedCoverImage = value
    },
    validateBlog () {
      console.log(this.blog.body)
      this.feedback = []
      if (!this.selectedCoverImage) {
        this.feedback.push('All blog posts require a cover image')
      }
      if (!this.blog.body) {
        this.feedback.push('You need to supply some blog content')
      }
      if (!this.title) {
        this.feedback.push('You need to supply a title')
      }
      if (this.feedback.length === 0) {
        return true
      } else {
        return false
      }
    },
    methodToRunOnSelect (payload) {
      this.object = payload
    },
   

    deleteBlog () {
      deleteBlog(this.blog.uid)
      this.selectedAuthor = null
      this.blog = []
      this.uploadCoverImage = null
      this.selectedCoverImage = null
      this.users = null
      this.feedback = []
      this.title = null
      this.value = []
      this.$router.push({ name: 'BlogAdmin' })
      this.project = null
    },
    processTags () {
        this.addNewTagsToFirebase()
        this.updatePostTagsToFirebase()
    },
    addNewTagsToFirebase () {
          if(this.resolvedTags.length > 0 ){
             postNewTagsToFirebase(this.resolvedTags)
          }
    },

    updatePostTagsToFirebase() {
        updatePostTagsToFirebase(this.value, this.blog.uid)
    },
    publishBlog () {
      if (this.validateBlog()) {
        editBlogToFirebase(this.blog, this.blog.uid, this.selectedCoverImage, this.$store.getters.userinformation.name, this.title, true, this.value, this.project)
        this.processTags()
        this.$router.push({ name: 'BlogAdmin' })
      }
    },
    draftBlog () {
      if (this.validateBlog()) {
        editBlogToFirebase(this.blog, this.blog.uid, this.selectedCoverImage, this.$store.getters.userinformation.name, this.title, false, this.value, this.project)
        this.processTags()
        this.$router.push({ name: 'BlogAdmin' })
      }
    },

    onFileSelected (event) {
      this.uploadCoverImage = event.target.files[0]
      console.log(this.uploadCoverImage)
    },
    onUpload () {
      const fd = new FormData()
      fd.append('image', this.uploadCoverImage, this.uploadCoverImage.name)
      axios.post('https://us-central1-skypet-9792e.cloudfunctions.net/uploadFile', fd, {
        onUploadProgress: uploadEvent => {
          console.log('Upload Progress: ' + Math.round(uploadEvent.loaded / uploadEvent.total * 10) + '%')
        }
      })
        .then(res => {
          console.log(res)
          this.selectedCoverImage = this.uploadCoverImage.name
        })
    }
  },

      getImageUrlViaResolution (fileName, resolution, bucketName) {
      const split = fileName.split('.')
      const filename = split[0]
      const extension = split[1]
      const bucket = bucketName || 'skypet_blog_images'
      const baseUrl = 'https://storage.googleapis.com/'
      let res = null
      if (!resolution) { res = '' }
      if (resolution === 1920) { res = '@s_1920' }
      if (resolution === 720) { res = '@s_720' }
      if (resolution === 100) { res = '@s_100' }
      const imageUrl = baseUrl + bucket + '/' + filename + res + '.' + extension
      return imageUrl
    },
     handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      const formData = new FormData()
      formData.append('image', file)
      const filename = []
      for (const value of formData.values()) {
        filename.push(value.name)
      }

      console.log(filename[0])
      axios.post('https://us-central1-skypet-9792e.cloudfunctions.net/uploadFile', formData, {
        onUploadProgress: uploadEvent => {
          console.log('Upload Progress: ' + Math.round(uploadEvent.loaded / uploadEvent.total * 10) + '%')
        }
      })
        .then(() => {
          const imageUrl = this.getImageUrlViaResolution(filename[0], 720)
          setTimeout(() => {
            const url = imageUrl // Get url from response
            Editor.insertEmbed(cursorLocation, 'image', url)
            resetUploader()
          }, 4000)
          console.log(imageUrl)
        })
        .catch(err => {
          console.log(err)
        })
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
